// extracted by mini-css-extract-plugin
export default {"timelineDate":"ccf-consumer-card-interactions-list-view_timelineDate__+w6AT"};